import { useModel } from "@stem-sims/nexus"
import { PulseLoader } from "react-spinners"
import { useCallback } from "react"
import { createReviewGroup, deleteReviewGroup, getReviewGroups } from "shared/routes/reviewRoutes"
import { toast } from "react-toastify"
import EditingListPane from "../EditingListPane"
import { ReviewGrades, ReviewGradeType } from "shared/types/science35Types"

const science38Grades: ReviewGradeType[] = [...ReviewGrades]

export default function EditingReviewGroups() {

    const { loading, response: reviewGroups, refreshModel: refresh } = useModel({
        model: getReviewGroups,
        props: { applyFilter: false, gradeLevels: science38Grades },
    })

    const createReviewCallback = useCallback(async () => {
        try {
            const message = await createReviewGroup({})
            toast.success(message)
            refresh()
        } catch (err) {
            toast.error(err)
        }
    }, [refresh])

    const deleteReviewCallback = useCallback(async (values: { id: string }) => {
        try {
            const message = await deleteReviewGroup(values.id)
            toast.success(message)
            refresh()
        } catch (err) {
            toast.error(err)
        }
    }, [refresh])

    if (loading || !reviewGroups) {
        return <>
            <PulseLoader />
        </>
    }

    return <>
        <div className="w-50 m-auto">
            <EditingListPane
                parent={null}
                items={reviewGroups.map((group) => ({ id: group.groupId, name: group.name }))}
                itemType="review-group"
                createItem={createReviewCallback}
                updateItem={null}
                deleteItem={deleteReviewCallback}
            />
        </div>
    </>
}
